'use client';

import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

export enum ORDERBOOK_DISPLAY_TYPE {
	VERTICAL = 'VERTICAL',
	HORIZONTAL = 'HORIZONTAL',
}

interface Params {
	isMini?: boolean;
}

export const useOrderbookDisplayPreference = ({ isMini }: Params = {}) => {
	const [savedOrderbookDisplayType, setSavedOrderbookDisplayType] =
		useSyncLocalStorage('orderbook_display', ORDERBOOK_DISPLAY_TYPE.VERTICAL);

	const isMobileScreenSize = useIsMobileScreenSize();

	const displayType = (() => {
		if (isMini) {
			return ORDERBOOK_DISPLAY_TYPE.VERTICAL;
		}

		if (isMobileScreenSize) {
			return ORDERBOOK_DISPLAY_TYPE.HORIZONTAL;
		}

		return savedOrderbookDisplayType;
	})();

	return {
		orderbookDisplayType: displayType,
		setOrderbookDisplayType: setSavedOrderbookDisplayType,
	};
};
